import React from 'react';
import {View, StyleSheet, TouchableOpacity, Text} from 'react-native';
import {useTheme, Surface} from 'react-native-paper';
import {Icon} from '../../shared/components/Icon';

interface DashboardScreenProps {
  navigation?: any;
}

export const DashboardScreen: React.FC<DashboardScreenProps> = ({navigation}) => {
  const theme = useTheme();

  const goToScan = () => {
    if (navigation) {
      navigation.navigate('Scan');
    }
  };

  return (
    <View
      style={[styles.container, {backgroundColor: theme.colors.background}]}>
      {/* Fondo decorativo sutil */}
      <View
        style={[
          styles.decorCircle,
          {
            backgroundColor: theme.colors.primary
              ? `${theme.colors.primary}12`
              : 'rgba(25, 118, 210, 0.08)',
          },
        ]}
      />
      <View style={styles.content}>
        <View style={styles.header}>
          <Icon
            name="qr-code-scanner"
            size={40}
            color={theme.colors.primary}
          />
          <Text style={[styles.headerTitle, {color: theme.colors.onBackground}]}>
            Escáner de beneficios
          </Text>
          <Text
            style={[
              styles.headerSubtitle,
              {color: theme.colors.onSurfaceVariant},
            ]}>
            Listo para canjear servicios
          </Text>
        </View>

        <TouchableOpacity
          onPress={goToScan}
          activeOpacity={0.85}
          style={styles.buttonWrapper}>
          <Surface
            style={[styles.scanButton, {backgroundColor: theme.colors.primary}]}
            elevation={4}>
            <View style={styles.scanIconContainer}>
              <Icon name="qr-code-2" size={80} color="#fff" />
            </View>
            <Text style={styles.scanButtonTitle}>Escanear Código QR</Text>
            <Text style={styles.scanButtonSubtitle}>
              Escanea el código QR de un beneficiario para canjear un servicio
            </Text>
          </Surface>
        </TouchableOpacity>

        <View style={styles.footerTip}>
          <Icon
            name="info-outline"
            size={16}
            color={theme.colors.onSurfaceVariant}
          />
          <Text
            style={[styles.footerTipText, {color: theme.colors.onSurfaceVariant}]}>
            Apunta la cámara al código QR del beneficiario
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  decorCircle: {
    position: 'absolute',
    width: 280,
    height: 280,
    borderRadius: 140,
    top: -80,
    right: -80,
  },
  content: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  header: {
    alignItems: 'center',
    marginBottom: 32,
  },
  headerTitle: {
    fontSize: 26,
    fontWeight: '700',
    marginBottom: 4,
    marginTop: 12,
  },
  headerSubtitle: {
    fontSize: 18,
    fontWeight: '500',
  },
  buttonWrapper: {
    width: '100%',
    maxWidth: 320,
  },
  scanButton: {
    borderRadius: 24,
    overflow: 'hidden',
    padding: 32,
    alignItems: 'center',
  },
  scanIconContainer: {
    width: 120,
    height: 120,
    borderRadius: 60,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 24,
  },
  scanButtonTitle: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#fff',
    marginBottom: 8,
    textAlign: 'center',
  },
  scanButtonSubtitle: {
    fontSize: 18,
    color: 'rgba(255, 255, 255, 0.9)',
    textAlign: 'center',
    lineHeight: 24,
  },
  footerTip: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginTop: 24,
    paddingHorizontal: 16,
  },
  footerTipText: {
    fontSize: 17,
    fontWeight: '500',
  },
});
